import { useState, createContext, useEffect } from 'react';
import { db } from '../services/firebaseConnection';
import { addDoc, collection, getDocs } from 'firebase/firestore';
import bcrypt from 'bcryptjs';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const AuthContext = createContext({});

const EXPIRATION_DAYS = 7;
const EXPIRATION_TIME = EXPIRATION_DAYS * 24 * 60 * 60 * 1000; // 7 dias em ms

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [firstAccess, setFirstAccess] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    function loadUser() {
      const storageUser = localStorage.getItem('@userLogado');
  
      if (storageUser) {
        try {
          const parsedUser = JSON.parse(storageUser);
          const now = Date.now();
          const expirationTime = 7 * 24 * 60 * 60 * 1000; // 7 dias em ms
  
          if (parsedUser.lastLogin && now - parsedUser.lastLogin < expirationTime) {
            // Se ainda está dentro do prazo, mantém logado
            parsedUser.lastLogin = now; // Atualiza o tempo
            localStorage.setItem('@userLogado', JSON.stringify(parsedUser));
            setUser(parsedUser);
          } else {
            // Caso contrário, faz logout
            logout();
          }
        } catch (error) {
          console.error("Erro ao processar os dados do usuário:", error);
          logout();
        }
      } else {
      }
  
      setLoading(false);
    }
  
    loadUser();
  }, []);

  async function logout() {
    localStorage.removeItem('@userLogado');
    setUser(null);
    toast.success('Logout realizado com sucesso.');
  }

  async function signIn(email, password) {
    setLoadingAuth(true);
    try {
      const querySnapshot = await getDocs(collection(db, 'User'));
      const userDoc = querySnapshot.docs.find((doc) => doc.data().email.toLowerCase() === email.toLowerCase());

      if (!userDoc) {
        toast.error('Usuário não encontrado!');
        setLoadingAuth(false);
        return;
      }

      const userData = userDoc.data();
      const passwordMatch = bcrypt.compareSync(password, userData.password);

      if (!passwordMatch) {
        toast.error('Senha incorreta!');
        setLoadingAuth(false);
        return;
      }

      const data = {
        uid: userDoc.id,
        email: userData.email,
        name: userData.name,
        cargo: userData.cargo,
        lastLogin: Date.now() // Salva o timestamp do login
      };

      setUser(data);
      localStorage.setItem('@userLogado', JSON.stringify(data));

      if (bcrypt.compareSync('123456', userData.password)) {
        setFirstAccess(true);
        navigate('/primeiro-acesso');
        setLoadingAuth(false);
        return;
      }
      navigate('/home');
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      toast.error('Erro ao fazer login!');
    } finally {
      setLoadingAuth(false);
    }
  }

  // NOVA FUNÇÃO SIGNUP
  async function signUp(userData) {
    setLoadingAuth(true);
    
    try {
      // Verificar se o email já existe
      const querySnapshot = await getDocs(collection(db, 'User'));
      const existingUser = querySnapshot.docs.find((doc) => 
        doc.data().email.toLowerCase() === userData.email.toLowerCase()
      );

      if (existingUser) {
        toast.error('Este email já está cadastrado!');
        setLoadingAuth(false);
        return;
      }

      // Criptografar a senha
      const saltRounds = 10;
      const hashedPassword = bcrypt.hashSync(userData.password, saltRounds);
      
      // Preparar os dados do usuário
      const userDataToSave = {
        ...userData,
        password: hashedPassword, // Salvar senha criptografada
        createdAt: new Date(),
      };
      
      // Salvar no Firestore
      const docRef = await addDoc(collection(db, 'User'), userDataToSave);
      
      toast.success('Usuário cadastrado com sucesso!');
      console.log('Usuário criado com ID: ', docRef.id);
      
      // Opcional: redirecionar após cadastro
      // navigate('/login');
      
    } catch (error) {
      console.error('Erro ao cadastrar usuário:', error);
      toast.error('Erro ao cadastrar usuário!');
    } finally {
      setLoadingAuth(false);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        userId: user ? user.uid : null,
        signIn,
        signUp,        // ← Função signUp adicionada
        logout,
        loadingAuth,
        loading,
        setUser,
        firstAccess,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;